import { IntakeState, RetainerState, ConsentFormState } from "../types";
import { PropertyAttributes } from "../types";

export const DefaultClientPortalState = {
    page: -1,
    portalId: 0,
    appId: '',
    processor: {},
    appCode: ''
};

export const DefaultIntakeState: IntakeState = {
    propertyType: '',
    propertyAddress: '',
    streetNumber: '',
    streetNumberSuffix: '',
    streetName: '',
    unitType: '',
    unitNumber: '',
    city: '',
    postalCode: '',
    closingDate: null,
    propertyPrice: '',
    mortgageFile: false,
    dataLoaded: false,
    province: ''
}

export const defaultPropertyAttributeState: PropertyAttributes = {
    swimmingPool: false,
    lakeFrontage: false,
    drilledWell: false,
    privateRoad: false,
    accessedViaHighway: false,
    condoUnit: false,
    hasMultipleUnits: false,
    homeIsNew: false,
    hasABoutHouse: false,
    sharesDriveway: false,
    currentlyHasTenants: false,
    notOccupilableYearRound: false,
    accessedViaWaterOnly: false,
    hasAnElevator: false,
    purchasedAsRental: false
}

export const PropertyAttributesData = [
    {
        name: 'Swimming Pool',
        icon: 'fa-regular fa-person-swimming',
        value: 'swimmingPool'
    },
    {
        name: 'Lake Frontage',
        icon: 'fa-regular fa-water',
        value: 'lakeFrontage'
    },
    {
        name: 'Drilled Well',
        icon: 'fa-regular fa-sink',
        value: 'drilledWell'
    },
    {
        name: 'Private Road',
        icon: 'fa-regular fa-road',
        value: 'privateRoad'
    },
    {
        name: 'Accessed via Highway',
        icon: 'fa-regular fa-route-highway',
        value: 'accessedViaHighway'
    },
    {
        name: 'Condo Unit',
        icon: 'fa-regular fa-apartment',
        value: 'condoUnit'
    },
    {
        name: 'Has Multiple Units',
        icon: 'fa-regular fa-apartment',
        value: 'hasMultipleUnits'
    },
    {
        name: 'Home is New',
        icon: 'fa-regular fa-home',
        value: 'homeIsNew'
    },
    {
        name: 'Has Boat House',
        icon: 'fa-regular fa-ship',
        value: 'hasABoatHouse'
    },
    {
        name: 'Shares Driveway',
        icon: 'fa-regular fa-road-circle-check',
        value: 'sharesDriveway'
    },
    {
        name: 'Currently has Tenants',
        icon: 'fa-regular fa-people-group',
        value: 'currentlyHasTenants'
    },
    {
        name: 'Not Occupiable Year-Round',
        icon: 'fa-regular fa-snowflake',
        value: 'notOccupilableYearRound'
    },
    {
        name: 'Has an Elevator',
        icon: 'fa-regular fa-elevator',
        value: 'hasAnElevator'
    },
    {
        name: 'Accessed Via Water Only',
        icon: 'fa-regular fa-ship',
        value: 'accessedViaWaterOnly'
    },
    {
        name: 'Purchase as Rental',
        icon: 'fa-regular fa-dollar-sign',
        value: 'purchasedAsRental'
    },
];

export const FontAwesomeIconNames = {
    lightWord: 'fa-light fa-file-word',
    lightPdf: 'fa-light fa-file-pdf',
    lightImage: 'fa-light fa-file-image',
    lightFileVideo: 'fa-light fa-file-video',
    lightFileExcel: 'fa-light fa-file-excel',
    lightFilePowerpoint: 'fa-light fa-file-powerpoint',
    lightFile: 'fa-light fa-file',
}

export const defaultRetainerState: RetainerState = {
    retainerRequired: false,
    defaultRetainerRequired: false,
    textBoxRetainerRequired: false,
    uploadRetainer: false,
    textBasedRetainer: null
}

export const defaultConsentFormState: ConsentFormState = {
    consentFormRequired: false,
    defaultConsentFormRequired: false,
    textBoxConsentFormRequired: false,
    uploadConsentForm: false,
    textBasedConsentForm: null
};

export const evenTimes = ['9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM'];
export const oddTimes = ['9:30 AM', '10:30 AM', '11:30 AM', '12:30 PM', '1:30 PM', '2:30 PM', '3:30 PM', '4:30 PM', '5:30 PM'];

export const defaultMortgageInformation = {
    primaryMortgage: {
        mortgageAmount: '',
        mortgageLender: '',
        firstPaymentDate: '',
        lastPaymentDate: '',
        lenderContactName: '',
        lenderContactEmail: '',
        lenderContactPhone: ''
    },
    secondaryMortgage: {
        mortgageAmount: '',
        mortgageLender: '',
        firstPaymentDate: '',
        lastPaymentDate: '',
        lenderContactName: '',
        lenderContactEmail: '',
        lenderContactPhone: ''
    }
}

export const DefaultCustomField = { type: 'text', name: '', value: '', perClient: false, identifier: null };

export const DefaultDocumentRequests = [{ documentName: '' }];

export const DefaultDocumentResponse = { Docs: [] };